export const DRUG_PROGRAM_URL = "https://www.fmcsa.dot.gov/regulations/drug-alcohol-testing-program";
export const CLEARINGHOUSE_URL = "https://clearinghouse.fmcsa.dot.gov/";
export const DRUG_ITEM = { id: "drug_testing", label: "Drug & alcohol testing program", notifyLabel: "Drug & alcohol testing program" };

export const drugTestingApplies = (p) => {
  const drivers = p?.drivers || [];
  return !drivers.length || drivers.some((d) => d.cdl_class);
};

export const drugTestingDone = (p) => (p?.filings || []).some((f) => f.key === "drug_testing" && f.status === "completed");
